import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';
import { OversignTimeFeatureComponent } from '../oversign-time/oversign-time-feature/oversign-time-feature.component';

const log = new LoggingService();
export const OversignTimeRoute: Ng2StateDeclaration = {
    name: 'timecardoversign',
    url: '/timecardoversign',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: OversignTimeFeatureComponent
};
